module.exports = __webpack_public_path__ + "img/s5.b3deacc3.png";